export class AdmissionTypeCount {

 TotalAdmmited : number;
 DayAdmissions : number;
}
